import { IS_HOMOLOGATION } from 'utils/constants';

const LOCAL_HOSTNAMES = ['localhost', '127.0.0.1', '::1', '[::1]'];

/** Na máquina do dev o ambiente já é óbvio, então a faixa só atrapalha. */
const isLocalhost = () => LOCAL_HOSTNAMES.includes(window.location.hostname);

/**
 * Faixa fixa no topo que identifica o ambiente de homologação (a mesma do Joga Junto).
 *
 * Fica acima de tudo da aplicação, inclusive das modais e toasts, e não intercepta
 * cliques. Diferente do Joga Junto, a página desce a altura da faixa, porque o logo
 * do Prêmio BB encosta no topo e ficaria coberto.
 *
 * O brilho é um degradê recortado nas letras (`bg-clip-text`): a onda clara varre o
 * texto e descansa fora dele. Sem a animação o degradê fica parado na faixa escura,
 * então o texto continua preto e legível.
 */
/** Altura da faixa: o texto (linha de 1.25rem) mais os espaços de cima e de baixo. */
const ALTURA_DA_FAIXA = 'h-[calc(env(safe-area-inset-top)_+_2rem)]';

const EnvironmentBanner = () => {
  if (!IS_HOMOLOGATION || isLocalhost()) return null;

  return (
    <>
      <div
        role="status"
        className={`pointer-events-none fixed inset-x-0 top-0 z-[99999] flex select-none items-end justify-center bg-yellow-bb/90 pb-1.5 shadow-[0_0_18px_rgba(252,252,48,0.45)] ${ALTURA_DA_FAIXA}`}
      >
        <span className="animate-text-shine bg-[linear-gradient(100deg,#000_45%,rgba(0,0,0,0.2)_50%,#000_55%)] bg-[length:250%_100%] bg-clip-text text-xs/5 font-bold tracking-[0.2em] text-transparent motion-reduce:animate-none sm:text-sm/5">
          AMBIENTE DE HOMOLOGAÇÃO
        </span>
      </div>
      {/* A faixa é fixa; este espaço empurra a página para ela não cobrir o topo do header. */}
      <div aria-hidden className={ALTURA_DA_FAIXA} />
    </>
  );
};

export default EnvironmentBanner;
